import styled from 'styled-components';
import { colorUsage, fontSize, getSpacing } from 'stylesheet';
import { Minus, Plus } from 'theme/icons';
var MaxSizeInfo = styled.span.withConfig({
  displayName: "CoverImagesFieldstyle__MaxSizeInfo",
  componentId: "sc-6nakm9-0"
})(["color:", ";font-size:", ";"], colorUsage.textColorLight, fontSize.smaller);
var AccordionContainer = styled.div.withConfig({
  displayName: "CoverImagesFieldstyle__AccordionContainer",
  componentId: "sc-6nakm9-1"
})(["display:", ";margin-top:", ";"], function (_ref) {
  var visible = _ref.visible;
  return visible ? 'block' : 'none';
}, getSpacing(2));
/**
 * It is necessary to use classes here because we don't have the control of the accordion (it is managed by MUI)
 * Example here : https://bleepcoder.com/material-ui/521443526/accordion-summary-custom-collapse-icon
 */

var Icon = styled.div.withConfig({
  displayName: "CoverImagesFieldstyle__Icon",
  componentId: "sc-6nakm9-2"
})(["& > .closedAccordion{display:block;}& > .openedAccordion{display:none;}.Mui-expanded & > .closedAccordion{display:none;}.Mui-expanded & > .openedAccordion{display:block;}"]);
var PlusIcon = styled(Plus).withConfig({
  displayName: "CoverImagesFieldstyle__PlusIcon",
  componentId: "sc-6nakm9-3"
})(["width:15px;height:15px;path{fill:", ";}"], colorUsage.iconForeground);
var MinusIcon = styled(Minus).withConfig({
  displayName: "CoverImagesFieldstyle__MinusIcon",
  componentId: "sc-6nakm9-4"
})(["width:15px;height:15px;path{fill:", ";}"], colorUsage.iconForeground);
export { MaxSizeInfo, AccordionContainer, Icon, PlusIcon, MinusIcon };